<template>
    <div class="uk-card-body shop-filter-row" :class="{'uk-disabled tm-disabled': multipleMode && multipleModeProperty.id !== property.id}">

        <div class="uk-h4 uk-position-relative">
            <div class="uk-flex-inline">
                <span>{{ property.name }}</span>
                <div v-if="property.description">
                    <span class="tm-help-icon" uk-icon="icon: question; ratio: .8"></span>
                    <div uk-drop="mode: click;boundary: .shop-filter-row" class="tm-help-drop">
                        <span uk-icon="triangle-up" class="uk-icon"></span>
                        <div v-html="property.description" class="uk-card uk-card-body uk-card-default">
                        </div>
                    </div>
                </div>
            </div>
            <a class="uk-button uk-position-center-right uk-hidden@s"><span uk-icon="icon: plus; ratio: 1.5;" class="uk-icon revealing-toggle" :class="[openedToggle ? 'opened-toggle' : '']" :uk-toggle="'animation: uk-animation-fade;target: #toggle-usage-' + property.id" @click="chengetoggle"></span></a>
        </div>

        <div :id="'toggle-usage-' + property.id" aria-hidden="true" hidden>
            <div class="filter-list">
                <ul class="uk-list uk-text-small@s">
                    <li v-for="propertyValue in propertyValues" :key="propertyValue.id">
                        <label>
                            <input @change="selectPropertyValue" v-model="checkedPropertyValues" :value="propertyValue.id"
                                   class="uk-checkbox uk-margin-xsmall-right"
                                   type="checkbox"> {{ propertyValue.value_varchar }}
                        </label>
                    </li>
                </ul>
            </div>
            <div v-if="multipleMode === false" class="uk-text-meta filter-text uk-flex-inline tm-filter-footer">

                <a v-if="hasNotSelected && moreThanOne" @click="turnMultipleMode"><span class="uk-icon"><svg width="18" height="18" viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg"> <polyline fill="none" stroke="#000" stroke-width="1.1" points="4,10 8,15 17,4" /> <polyline fill="none" stroke="#000" stroke-width="1.1" points="9,10 13,15 22,4" /></svg></span>Несколько значений</a>

                <a v-if="checkedPropertyValues.length > 0" @click="clear" class="uk-margin-auto-left"><span uk-icon="close" class="uk-icon" style="width: 14px;"></span>Очистить</a>
            </div>
            <div v-else-if="multipleMode && multipleModeProperty.id === property.id"
                 class="uk-text-meta filter-text uk-flex-inline tm-filter-footer">
                <a @click="acceptMultipleMode">Применить</a>
                <a @click="cancelMultipleMode" class="uk-margin-auto-left">Отмена</a>
            </div>

            <div class="uk-text-meta filter-text" v-else>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ShopFilterRow",
        props: {
            property: {
                type: Object,
                required: true,
            },
            propertyValues: {
                type: Array,
                required: true,
            },
            multipleMode: {
                type: Boolean,
                required: true,
                default() {
                    return false
                }
            },
            multipleModeProperty: {
                type: Object,
                default() {
                    return {}
                }
            },
            selected: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        watch: {
            selected() {
                this.checkedPropertyValues = this.selected;
            }
        },
        computed: {
            hasNotSelected() {
                return this.checkedPropertyValues.length !== this.propertyValues.length
            },
            moreThanOne() {
                return this.propertyValues.length > 1
            }
        },
        data() {
            return {
                checkedPropertyValues: this.selected,
                openedToggle: false
            }
        },
        methods: {
            selectPropertyValue() {
                if (this.multipleMode === false) {
                    this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
                }
            },
            turnMultipleMode() {
                this.$emit('update:multipleModeProperty', this.property);
                this.$emit('update:multipleMode', true);
            },
            cancelMultipleMode() {

                this.checkedPropertyValues = [];

                this.$emit('update:multipleModeProperty', {});
                this.$emit('update:multipleMode', false);
            },
            acceptMultipleMode() {
                this.$emit('update:multipleModeProperty', {});
                this.$emit('update:multipleMode', false);

                this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
            },
            clear() {
                this.checkedPropertyValues = [];
                this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
            },
            chengetoggle() {
                if(this.openedToggle === false) {
                    this.openedToggle = true
                }else{
                    this.openedToggle = false
                }
            }
        }
    }
</script>

<style scoped>
    .tm-disabled {
        color: #999;
    }
</style>



// WEBPACK FOOTER //
// ShopFilterRow.vue?f93d5562